export enum ChartColors {
  Lead = '#4F5A9F',
  Oppty = '#008989'
}
